<modal-popup [flexible]="true" [focusOnOpen]="false"
[afterTitle]="dirtyBtns"
 [isOpen]="true" (onClose)="close()" [title]="'translate.cat.libraryEntryDetails'">
<h3>{{ "translate.general.phrase" | translate}}</h3>
<div>
    <textarea *ngIf="editModeSw" class="edit-phrase-area" pTextarea [(ngModel)]="editPhraseText" autoResize="true"></textarea>
    <div *ngIf="!editModeSw" class="phrase-txt">
          <span *ngIf="phrase.phraseWords.length == 0">
            {{ phrase.phraseText }}
          </span>
          <formatted-phrase *ngIf="phrase.phraseWords.length > 0" [phraseWords]="phrase.phraseWords"
            [grammarSpellingIssues]="phrase.grammarSpellingIssues"
            [referenceIssues]="phrase.referenceIssues"></formatted-phrase>
        </div>
    <div *ngIf="!phrase.hasId && (!phrase.typeCode || !phrase.subTypeCode)" class="w-full t-row--med">
        <p class="fs-small t-row--small fw-semibold">
            {{ "translate.cat.phraseType" | translate }}
        </p>
        <ng-container *ngTemplateOutlet="typesTree"></ng-container>

    </div>
    <div style="min-width: 720px; margin-top: 10px; margin-bottom: 10px">
        <h3 *ngIf="phrase.addInstr && phrase.addInstr.length > 0">
            {{ "translate.rev.instructions" | translate }}
        </h3>

        <cat-add-instr *ngFor="let instr of phrase.addInstr" [instr]="instr" (onDelete)="onDeleteInstr(instr)"
            [editable]="editable"></cat-add-instr>

        <a *ngIf="editable" (click)="addInstr()" class="add-link" style="margin-top: 5px; margin-bottom: 5px">
            <i class="fas fa-plus" style="margin-bottom: 10px !important"></i>
            &nbsp;
            {{ "translate.cat.addMoreInstr" | translate }}
        </a>
      <div>
        <button *ngIf="phrase.hasId && editable" class="t-button-outline t-button-warn" [disabled]="loading"
          (click)="onDeleteClicked()">
          <span>{{ "translate.cat.deletePhrase" | translate }}</span>
        </button>

        <button *ngIf="!phrase.hasId" class="t-button" [disabled]="loading || !validateBeforeSave()"
          (click)="onSaveClicked()">
          {{ "translate.general.save" | translate }}
        </button>
      </div>
    </div>
</div>
</modal-popup>
<ng-template #typesTree>
  <p-tree class="fs-small" [value]="catPhraseTypesTree" [(selection)]="selectedPhraseType" scrollHeight="250px"
    selectionMode="single" filter="true" (onNodeSelect)="onTypeSelected($event)"></p-tree>
</ng-template>

<ng-template #dirtyBtns>
  <div *ngIf="phrase.hasId && isDirty()" class="t-small">
    <button class="t-button t-button-warn" [disabled]="loading || !validateBeforeSave()" (click)="onSaveClicked()">
      {{ "translate.general.saveChanges" | translate }}
    </button>
    &nbsp;
    <button class="t-button-outline t-button-warn" [disabled]="loading" (click)="discardChanges()">
      {{ "translate.general.discardChanges" | translate }}
    </button>
  </div>

</ng-template>